import type {SVGProps} from 'react';
import * as React from 'react';
export const MinusCircleIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		// viewBox="0 0 24 24"
		{...props}
	>
		<g
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit={10}
			strokeWidth={1.5}
			clipPath="url(#a)"
		>
			<path d="M12 23.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11ZM6.378 12.451h11.049" />
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 .5h24v24H0z" />
			</clipPath>
		</defs>
	</svg>
);
